import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

interface ProductInformationProps {
    isMobile: boolean;
    dataInformations: String;
    informationTitle: string;
}

export const ProductInformation: React.FC<ProductInformationProps> = ({ isMobile, dataInformations, informationTitle }) => {
    const informations = dataInformations.split('\n');

    return (
        <Row className={`rounded bg-white p-4 ${isMobile ? "" : "mt-4 shadow"}`}>
            <Col id='moreinformations'>
                <h5>{informationTitle}</h5>
                <hr />
                {informations.map((info, index) => (
                    <p key={index}>{info}</p>
                ))}
            </Col>
        </Row>
    );
};
